import type { Buffer } from "../model/buffer";
import type { Cursor } from "../model/cursor";
import type { Range } from "../model/range";
import { classAt, stepBackward, stepForward } from "../motions/word-class";

/** `iw` / `aw`: カーソル位置の単語（または空白の連続）を対象にする。 */
export function wordTextObject(buffer: Buffer, cursor: Cursor, around: boolean): Range {
  const cls = classAt(buffer, cursor);

  let left = cursor;
  for (;;) {
    const prev = stepBackward(buffer, left);
    if (prev === null || prev.line !== left.line || classAt(buffer, prev) !== cls) {
      break;
    }
    left = prev;
  }

  let right = cursor;
  for (;;) {
    const next = stepForward(buffer, right);
    if (next === null || next.line !== right.line || classAt(buffer, next) !== cls) {
      break;
    }
    right = next;
  }

  if (!around) {
    return { start: left, end: right, kind: "inclusive" };
  }

  let end = right;
  let extendedForward = false;
  for (;;) {
    const next = stepForward(buffer, end);
    if (next === null || next.line !== end.line || classAt(buffer, next) !== "blank") {
      break;
    }
    end = next;
    extendedForward = true;
  }
  if (extendedForward) {
    return { start: left, end, kind: "inclusive" };
  }

  let start = left;
  for (;;) {
    const prev = stepBackward(buffer, start);
    if (prev === null || prev.line !== start.line || classAt(buffer, prev) !== "blank") {
      break;
    }
    start = prev;
  }
  return { start, end: right, kind: "inclusive" };
}
